const animationShowButtonOnScroll = () => {
	let button = document.getElementById('sticky-button');

	window.onscroll = function () {
		scrollFunction();
	};

	function scrollFunction() {
		if (
			document.body.scrollTop > 20 ||
			document.documentElement.scrollTop > 20
		) {
			button.style.visibility = 'visible';
			button.style.opacity = '1';
		} else {
			button.style.visibility = 'hidden';
			button.style.opacity = '0';
		}
	}
};

export default animationShowButtonOnScroll;
